import { combineReducers } from 'redux';

// Front
import Layout from './layout/reducer';

// Authentication Module
import Login from './auth/login/reducer';
import Forget from './auth/forgetpwd/reducer';

import User from "./user/reducer";
import Role from "./role/reducer";
import Profile from "./profile/reducer";
import General from "./general/reducer";
import Dashboard from './dashboard/reducer';
import Location from './location/reducer';
// import Setting from './setting/reducer';
import Permission from './permission/reducer';
import ReuseableReducer from './setting/reducer';
import Notification from './notification/reducer';
import Register from './auth/register/reducer';
import Credit from './credit/reducer';
import Doctor from './doctors/reducer';
import Customer from './customer/reducer';
import Order from './order/reducer';
import Admin from './admin/reducer';
import Report from './report/reducer';
import ShippingZone from './shippingZone/reducer';

const rootReducer = combineReducers({

    // public
    Layout,

    // Authentication
    Login,
    Register,
    Forget,
    General,
    Permission,
    // setting
    ReuseableReducer,
    User,
    Profile,
    Role,
    Dashboard,
    Location,
    Credit,
    Doctor,
    Customer,
    Order,
    Admin,
    Report,
    ShippingZone,
    Notification
});

export default rootReducer;